import "./AppearWrapper.scss"

export default function AppearWrapper({children, show}: {children: React.ReactNode, show: boolean}) {
    return (
        <div className={`appear-wrapper ${show ? 'show' : 'hide'}`}>
            {children}
        </div>
    )
}